import { render } from "./RegisterCourt.vue?vue&type=template&id=2f3149f8&scoped=true"
import script from "./RegisterCourt.vue?vue&type=script&lang=js"
export * from "./RegisterCourt.vue?vue&type=script&lang=js"

import "./RegisterCourt.vue?vue&type=style&index=0&id=2f3149f8&scoped=true&lang=css"

import exportComponent from "/var/www/html/garbage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3149f8"]])

export default __exports__